@let currentLocation = currentLocation$ | async;

<mat-toolbar [style.border-top-color]="currentLocation ? currentLocation.color : 'transparent'"
  [style.background-color]="color"
  role="heading"
  fxLayout="row"
  fxLayoutAlign="space-between center"
  >
  <!-- htmllint preset="none" -->
  <div id="logo-location-wrapper">
    <img class="logo" [src]="headerImage" [alt]="headerAltText">
    @if (currentLocation) {
      <div id="location-switcher">
        <form>
          <mat-form-field>
            <mat-select placeholder="Select" [value]="currentLocation['@id']" (selectionChange)="onLocationChange($event)">
              @for (location of availableLocations$ | async; track location) {
                <mat-option [value]="location['@id']">{{ location.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>
      </div>
    }
  </div>
  @if (isUserAuthenticated$ | async) {
    <app-navigation></app-navigation>
  }
  @if (authenticatedUser$ | async; as user) {
    <div class="account">
      <div class="account-img">
        <!--<app-user-badge [user]="currentUser$ | async"></app-user-badge>-->
      </div>
      <button mat-button [matMenuTriggerFor]="menu" class="account-name">
        {{ (authenticatedUser$ | async).firstName }} {{ (authenticatedUser$ | async).lastName }}
        <mat-icon class="material-icons">arrow_drop_down</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="onEditAccount(user['@id'])" class="account-window">{{'user.account' | translate}}</button>
        <button mat-menu-item (click)="onLogout()">{{ 'auth.logout' | translate }}</button>
      </mat-menu>
    </div>
  }
</mat-toolbar>
